import SpriteSymbol from "../../../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "pallet",
  "use": "pallet-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol viewBox=\"0 0 32 32\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"pallet\">\n    <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M14.667 14.6667H4.00033V22.6667H14.667V14.6667ZM28.0003 14.6667H17.3337V22.6667H28.0003V14.6667ZM14.667 4H4.00033V12H14.667V4ZM28.0003 4H17.3337V12H28.0003V4ZM29.3337 24V26.6667H28.0003V28H24.0003V26.6667H18.667V28H13.3337V26.6667H8.00033V28H4.00033V26.6667H2.66699V24H29.3337Z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol